import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useGettingPlaylistContent = () => {
  const { response: contents, onFetch: handleFetchContents } = useFetch(
    'playlist-contents',
    Api.PLAYLIST_CONTENTS
  );

  const onFetchContents = (id) => handleFetchContents({ pathParams: { id } });

  return {
    contents,
    onFetchContents,
  };
};

export default useGettingPlaylistContent;
